import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import React from "react";
import { Link } from "react-router-dom";

const HealthCenterStaffHeader = ({
  reloadCompanyMemberList = () => {},
  isCompanyModerator = false,
}) => {
  // -------- breadcrumb text --------
  const breadCrumbText = [
    { title: "Health Center", link: "/admin/clinicalmanagement/healthcenters" },
    { title: "Staffs" },
  ];

  return (
    <div className="bg-white mt-4 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          {/* -------- bread crumb ------------ */}
          <BreadCrumb breadCrumbText={breadCrumbText} top={false} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          <Link
            onClick={reloadCompanyMemberList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title="Reload"
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">Reload</span>
          </Link>
          <div
            className={
              isCompanyModerator
                ? "dropdown flex-fill flex-grow-sm-0"
                : "d-none"
            }
          >
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">Action</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#addLabelModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">Add Label</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deletewarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">Delete</span>
                </Link>
              </li>
            </ul>
          </div>
          <Link
            to="#"
            className={
              isCompanyModerator
                ? "btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
                : "d-none"
            }
            data-bs-toggle="modal"
            data-bs-target="#addCompanyMember"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>Add New</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HealthCenterStaffHeader;
